window.OpusNoATC = true;
(function (ns, fetch) {
  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
      if (res.url.includes(`/cart/add`) && res.ok && !res.url.includes('opus') && typeof window.opusOpen === "function") {
        window?.opusOpen?.();
        // el need hidden , only open opus cart
         const CartEl = document.querySelectorAll(
                '#cart-drawer'
              );
              for (const el of CartEl) {
                const item = el;
                item.style.display = 'none';
                item.style.visibility = 'hidden';
              }
      }
    });
    return response
  }
}(window, window.fetch))